import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import JsonLd from '../components/jsonld';
import SEO from '../components/seo';
import SearchComponent from '../components/search/search';

import CONTENT from '../static-content/search.json';

const propTypes = {
  geoSpace: PropTypes.string,
  seoSlug: PropTypes.string
};

/**
 * Renders the Search page
 *
 * @component renderSearchPage
 *
 * @param {string} geoSpace
 * @param {string} seoSlug
 *
 * @returns {JSX}
 */
const renderSearchPage = (geoSpace = null, seoSlug = null) => {
  const [query, setQuery] = useState('');

  useEffect(() => {
    // Extract the query parameter from the URL
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const queryParam = urlParams.get('query');
      if (queryParam) {
        setQuery(queryParam);
      }
    }
  }, []);

  /**
   * Renders the SEO metatag and structured data elements
   *
   * @function renderSEO
   *
   * @param {object} content
   * @param {string} slug
   * @param {string} query
   *
   * @returns {JSX}
   */
  const renderSEO = (content, slug, query) => {
    const newTitle = query ? `${content.SEO_TITLE} - Results for ${query}` : `${content.SEO_TITLE}`;
    const newDescription = query ? `${content.SEO_DESCRIPTION} - Results for ${query}` : `${content.SEO_DESCRIPTION}`;
    const queryUrl = query ? `https://www.credera.com/${slug}?query=${query}` : `https://www.credera.com/${slug}`;

    return (
      <>
        {/* Prevent search engines from indexing search results pages */}
        <meta name="robots" content="noindex, nofollow" />
        {/* Create SEO details with the query in title and description */}
        {query && <SEO title={newTitle} description={newDescription} slug={`${slug}?query=${query}`} />}
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: newTitle,
            alternateName: content.TITLE,
            description: newDescription,
            abstract: newDescription,
            headline: newTitle,
            inLanguage: 'en',
            url: queryUrl,
            isAccessibleForFree: true
          }}
        />
      </>
    );
};

  return (
    <>
      {renderSEO(CONTENT, seoSlug, query)}
      <SearchComponent geoSpace={geoSpace} />
    </>
  );
};

renderSearchPage.propTypes = propTypes;

export { renderSearchPage };
